var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3210_26309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 4.66671V3.46671C11.9999 2.71997 11.9999 2.3466 11.8546 2.06139C11.7268 1.8105 11.5228 1.60653 11.2719 1.4787C10.9867 1.33337 10.6133 1.33337 9.86659 1.33337H6.13325C5.38652 1.33337 5.01315 1.33337 4.72793 1.4787C4.47705 1.60653 4.27307 1.8105 4.14524 2.06139C3.99992 2.3466 3.99992 2.71997 3.99992 3.46671V4.66671M3.99992 12C3.37994 12 3.06995 12 2.81561 11.9319C2.12543 11.747 1.58633 11.2079 1.4014 10.5177C1.33325 10.2633 1.33325 9.95336 1.33325 9.33337V7.86671C1.33325 6.7466 1.33325 6.18655 1.55124 5.75873C1.74299 5.3824 2.04895 5.07644 2.42527 4.88469C2.85309 4.66671 3.41315 4.66671 4.53325 4.66671H11.4666C12.5867 4.66671 13.1467 4.66671 13.5746 4.88469C13.9509 5.07644 14.2569 5.3824 14.4486 5.75873C14.6666 6.18655 14.6666 6.7466 14.6666 7.86671V9.33337C14.6666 9.95336 14.6666 10.2633 14.5984 10.5177C14.4135 11.2079 13.8744 11.747 13.1842 11.9319C12.9299 12 12.6199 12 11.9999 12M9.99992 7.00004H11.9999M6.13325 14.6667H9.86659C10.6133 14.6667 10.9867 14.6667 11.2719 14.5214C11.5228 14.3936 11.7268 14.1896 11.8546 13.9387C11.9999 13.6535 11.9999 13.2801 11.9999 12.5334V11.4667C11.9999 10.72 11.9999 10.3466 11.8546 10.0614C11.7268 9.8105 11.5228 9.60653 11.2719 9.4787C10.9867 9.33337 10.6133 9.33337 9.86659 9.33337H6.13325C5.38652 9.33337 5.01315 9.33337 4.72793 9.4787C4.47705 9.60653 4.27307 9.8105 4.14524 10.0614C3.99992 10.3466 3.99992 10.72 3.99992 11.4667V12.5334C3.99992 13.2801 3.99992 13.6535 4.14524 13.9387C4.27307 14.1896 4.47705 14.3936 4.72793 14.5214C5.01315 14.6667 5.38652 14.6667 6.13325 14.6667Z",
    stroke: "#4C60E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3210_26309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter16X16);
export default __webpack_public_path__ + "static/media/printer-16x16.b7387046711a3c1fabf99924ad5b949f.svg";
export { ForwardRef as ReactComponent };